import { SuccessData } from 'types/api';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { BugReport } from '../types';
import { uploadMutations } from 'entities/modules/uploads';

type CreateSuggestionParams = Pick<BugReport, 'description' | 'title' | 'severity'> & {
  files: File[];
};

export const bugReportMutations = getMutations({
  createBugReport: {
    action: async ({ files, ...payload }: CreateSuggestionParams): Promise<SuccessData> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: 'feedback',
      });

      return executeApiCall({
        path: '/feedback/bug-report',

        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },
  },

  changeBugReportStatus: {
    action: async (payload: {
      status: string;
      comment: string;
      reportId: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/feedback/bug-report/status',

        payload,
      });
    },
  },

  sendBugReportContext: {
    action: async ({
      files,
      ...payload
    }: {
      files: File[];
      comment: string;
      reportId: string;
    }): Promise<SuccessData> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: 'feedback',
      });

      return executeApiCall({
        path: '/feedback/bug-report/context',

        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },
  },
});
